import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";

import * as API from "../../libs/service";

import Popup01 from "../popup/Popup01"
import { setTeams } from "../../redux/teamSlice";

export default function PopupPlusMember(props) {
    const {
        title,
        subTitle,
        text,
        lefttext,
        width,
        button,
        buttonCancel,
        func,
        setFunc,
        noneLoading,
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        max_width,
        member_set,
        popType,
        groupCrate,
        groupEdit,
        groupName,
        group_name_get,
        plusMember,
        member_email,
        teamId
    } = props;

    console.log("popup, teamId : ", teamId);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const lang = useSelector(state => state.langReducer.lang);

    const { mbData } = useSelector((s) => s.usersReducer);

    const [maxWidthCut, setMaxWidthCut] = useState(max_width);

    const [idTitleView, setIdTitleView] = useState(false);
    const [idValue, setIdValue] = useState('');
    const [idAster, setIdAster] = useState(true);
    const [idErr, setIdErr] = useState(0);

    const [nameTitleView, setNameTitleView] = useState(false);
    const [nameValue, setNameValue] = useState('');
    const [nameAster, setNameAster] = useState(true);
    const [nameErr, setNameErr] = useState(0);

    const [licenseStatus, setLicenseStatus] = useState(true);

    const [idSuc, setIdSuc] = useState(false);
    const [nameSuc, setNameSuc] = useState(false);
    const [valueSuc, setValueSuc] = useState(false);

    const [groupNameValue, setGroupNameValue] = useState('');
    const [memberPlusEmailValue, setMemberPlusEmailValue] = useState('');
    const [memberPlusEmailErr, setMemberPlusEmailErr] = useState(0);
    const [memberPlusUser, setMemberPlusUser] = useState(undefined);

    const [dropViewGroup, setDropViewGroup] = useState(false);

    const teams = useSelector((state) => state.teamReducer.teams);
    const teamNames = teams.map((x) => x.name);
    const currentName = teams.find((x) => x.id === teamId)?.name;
    console.log("teamId : ", teamId, ", currentName : ", currentName);
    const droplist_group = ["조직 전체", ...teamNames];
    const [dropGroup, setDropGroup] = useState(currentName);

    console.log("memberPlusEmailErr : ", memberPlusEmailErr);
    useEffect(() => {
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, []);

    useEffect(() => {
        /* console.log('idSuc', idSuc);
        console.log('nameSuc', nameSuc);
        console.log('valueSuc', valueSuc); */

        if (idSuc && nameSuc) {
            setValueSuc(true)
        } else {
            setValueSuc(false)
        }
    }, [idSuc, nameSuc, valueSuc]);

    useEffect(() => {
        if (groupEdit) {
            setGroupNameValue(groupName);
        }
    }, []);

    const setFunction = () => {
        if (setFunc) setFunc();
        dispatch(close());
    };

    const PlusMemberFunc = async () => {
        dispatch(loadingStart());

        console.log("mbData : ", mbData);
        const sender = {
            from: mbData.idx,
            teamId: teamId,
        }
        const res = await API.post(`etc/invite/${memberPlusEmailValue}/${lang === 0 ? 'ko' : 'en'}`, sender);
        console.log("res : ", res);
        dispatch(loadingEnd());
        if (res.data?.message === 'success') {
            dispatch(open({
                component:
                    <Popup01
                        max_width={'300px'}
                        text1={'초대 메일을 발송했습니다.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                    />
            }));
        } else {
            dispatch(open({
                component:
                    <Popup01
                        max_width={'300px'}
                        text1={'다른 조직에 소속된 멤버입니다.'}
                        longButton={lang === 0 ? '확인' : 'OK'}
                    />
            }));
        }
    }

    /* const PlusMemberFunc = async () => {
        let sender = {
            idx: mbData?.idx,
            user_email: idValue,
            user_name: nameValue,
            admin_email: mbData?.mb_email,
            admin_name: mbData?.mb_name,
            status: licenseStatus
        };

        console.log('sender', sender);
        dispatch(loadingStart());

        await API.post('v1/mypage/PlusMember', sender).then(({ data }) => {
            console.log('체크', data);
            
            setTimeout(() => {
                dispatch(loadingEnd());
                dispatch(open({
                    component: 
                        <Popup01 
                            max_width={'300px'}
                            text1={버가 등록되었습니다.'}
                            longButton={'확인'}
                        />
                }));
            }, 1000);

        }).catch(err => {
            console.log(err.response.data);
            dispatch(open({
                component: 
                    <Popup01 
                        x_btn={true}
                        text1={'오류가 발생했습니다.'}
                        longButton={'확인'}
                        setFunc={() => {
                            navigate(routes.Profile)
                        }}
                    />
            }));
        }).finally(() => {
            
        })
    } */


    const InputChange = (event) => {
        const { name, value } = event.target;

        if (name === "login_id") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setIdValue(value)

            if (value) {
                setIdAster(false);
                setIdTitleView(true)
            } else {
                setIdAster(true);
                setIdTitleView(false)
                setIdSuc(false)
            }

            if (!EmailChk.test(value)) {
                setIdErr(2);
                setIdSuc(false)
                return;
            } else {
                setIdErr(0);
            }

            if (value && EmailChk.test(value)) {
                setIdSuc(true)
            } else {
                setIdSuc(false)
            }
        }

        if (name === "name") {
            let NameChk = /^[가-힣a-zA-Z]*$/;
            setNameValue(value)

            if (value) {
                setNameAster(false);
                setNameTitleView(true)

                if (!NameChk.test(value)) {
                    setNameErr(1);
                    setNameSuc(false)
                    return;
                } else {
                    setNameErr(0);
                }
            } else {
                setNameAster(true);
                setNameTitleView(false)
            }

            if (value && NameChk.test(value)) {
                setNameSuc(true)
            } else {
                setNameSuc(false)
            }
        }

        if (name === "group_name") {
            setGroupNameValue(value)
        }

        if (name === "member_plus_email") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setMemberPlusEmailValue(value)

            if (!EmailChk.test(value)) {
                setMemberPlusEmailErr(3);
                return;
            } else {
                setMemberPlusEmailErr(0);
            }

            if (value && EmailChk.test(value)) {
                setIdSuc(true)
            } else {
                setIdSuc(false)
            }
        }
    }

    const handleChange = (e) => {
        setLicenseStatus(e.target.value === "1");
    };

    console.log("groupNameValue : ", groupNameValue);
    return (
        <>
            <div
                className={"popup_default01"}
                style={{
                    maxWidth: max_width ? maxWidthCut : '400px',
                    width: '100%',
                    marginLeft: 10,
                    marginRight: 10,
                }}
            >
                {x_btn &&
                    <div
                        className="popup_x_btn_box"
                        style={{

                        }}
                    >
                        <img src={require("../../assets/images/exit-icon.svg").default}
                            className="popup_x_btn"
                            onClick={() => {
                                dispatch(close());
                            }}
                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                        />
                        <div style={{ height: 16 }} />
                    </div>
                }
                <div
                    className={`popup_content_box profile plus_member`}
                    style={{

                    }}
                >

                    <div className="title_box">
                        {popType == 'group' ?
                            <>
                                <p>조직 {groupEdit ? '수정' : '등록'}</p>
                            </>
                            :
                            <>
                                <p>멤버 {member_set ? '수정' : '등록'}</p>
                            </>
                        }

                        {groupEdit &&
                            <span
                                onClick={() => {
                                    dispatch(open({
                                        component:
                                            <Popup01
                                                max_width={'400px'}
                                                text1={'조직을 삭제하시면'}
                                                text2={'소속된 멤버도 삭제됩니다.'}
                                                text3_b={'조직을 삭제하시겠습니까?'}
                                                buttonCancel={'닫기'}
                                                button={'삭제'}
                                                deleteGroup={true}
                                                setFunc={() => {
                                                    dispatch(loadingStart());
                                                    setTimeout(() => {
                                                        dispatch(open({
                                                            component:
                                                                <Popup01
                                                                    max_width={'300px'}
                                                                    x_btn={false}
                                                                    text1={'삭제되었습니다.'}
                                                                    longButton={lang === 0 ? '확인' : 'OK'}
                                                                />
                                                        }));
                                                        dispatch(loadingEnd());
                                                    }, 1000);
                                                }}
                                            />
                                    }));
                                }}
                            >
                                삭제하기
                            </span>
                        }



                        {member_set &&
                            <span
                                onClick={() => {
                                    dispatch(open({
                                        component:
                                            <Popup01
                                                max_width={'300px'}
                                                text1={'멤버를 삭제하시겠습니까?'}
                                                buttonCancel={'닫기'}
                                                button={'삭제'}
                                                setFunc={async () => {
                                                    dispatch(loadingStart());
                                                    const sender = {
                                                        from: mbData.idx,
                                                    }
                                                    const result = await API.deleteF(`team/${teamId}/email/${member_email}`, sender);
                                                    dispatch(setTeams(result.data.teams));
                                                    dispatch(open({
                                                        component:
                                                            <Popup01
                                                                max_width={'300px'}
                                                                x_btn={false}
                                                                text1={'삭제되었습니다.'}
                                                                longButton={lang === 0 ? '확인' : 'OK'}
                                                            />
                                                    }));
                                                    dispatch(loadingEnd());
                                                }}
                                            />
                                    }));
                                }}
                            >
                                삭제하기
                            </span>
                        }
                    </div>

                    {popType == 'group' &&
                        <div className="input_box">
                            <div
                                className="input_div"
                            >
                                <input
                                    type="text"
                                    placeholder="20자 이내로 입력하세요"
                                    name="group_name"
                                    maxLength={20}
                                    onChange={InputChange}
                                    value={groupNameValue}
                                />
                            </div>
                        </div>
                    }

                    {plusMember &&
                        <>
                            <p className="plus_member_comment">가입된 회원에서 멤버를 추가하실 수 있습니다.</p>
                            <div className="input_box plus_member">
                                <div
                                    className="input_div"
                                >
                                    <input
                                        type="text"
                                        placeholder="이메일 검색"
                                        name="member_plus_email"
                                        onChange={InputChange}
                                        value={memberPlusEmailValue}
                                    />
                                </div>

                                <button
                                    type="button"
                                    onClick={async () => {
                                        if (!idSuc) {
                                            setMemberPlusEmailErr(1);
                                        } else {
                                            setMemberPlusUser(undefined);
                                            const users = await API.get(`user/search/${memberPlusEmailValue}`, {}, true);
                                            console.log("users : ", users);
                                            if (users.data.length === 0) {
                                                setMemberPlusEmailErr(1);
                                            } else {
                                                setMemberPlusUser(users.data[0]);
                                            }
                                        }
                                    }}
                                >
                                    검색
                                </button>
                            </div>

                            {memberPlusEmailErr === 1 && <span className="err_msg id" style={{ marginTop: '12px' }}>존재하지 않는 회원입니다.</span>}
                            {memberPlusEmailErr === 2 || memberPlusEmailErr === 1 && <span className="err_msg id" style={{ marginTop: '12px', color: '#121316', fontWeight: '700' }}>{memberPlusEmailValue}</span>}
                            {memberPlusEmailErr === 3 && <span className="err_msg id" style={{ marginTop: '12px' }}>이메일이 유효하지 않습니다.</span>}
                            {memberPlusEmailErr === 4 && <span className="err_msg id" style={{ marginTop: '12px' }}>이메일을 검색해 주세요.</span>}
                            {memberPlusUser && <span className="err_msg id" style={{ marginTop: '12px', color: '#121316', fontWeight: '700' }}>{`${memberPlusUser.email} (${memberPlusUser.fullname})`}</span>}
                        </>
                    }

                    {member_set &&
                        <>
                            <div className="input_box plus_member get">
                                <div
                                    className="input_div"
                                >
                                    <input
                                        type="text"
                                        placeholder="이메일 검색"
                                        name="member_plus_email_get"
                                        value={member_email}
                                        readOnly
                                    />
                                </div>
                            </div>


                            <div
                                className={`drop_box popup_member_edit pop ${dropViewGroup ? 'on' : ''}`}
                                onClick={() => {
                                    setDropViewGroup(!dropViewGroup)
                                }}
                            >
                                {dropGroup}

                                {dropViewGroup &&
                                    <div className="drop_list">
                                        {droplist_group.map((x, i) => (
                                            <p
                                                key={i}
                                                onClick={() => {
                                                    setDropGroup(x);
                                                }}
                                            >
                                                {x}
                                            </p>
                                        ))}
                                    </div>
                                }
                            </div>
                        </>
                    }

                    {/* {member_set ?
                        <div className="input_box">
                            <div 
                                className="input_div pw_div"
                                style={{
                                    border: idTitleView ? '1px solid #0E6AF4' : ''
                                }}
                            >
                                <input 
                                    type="text"
                                    placeholder="이메일 입력" 
                                    className="input_pw"
                                    name="login_id"
                                    value="aiafefsa@nver.com"
                                    readOnly
                                />
                            </div>

                            <div 
                                className="input_div pw_div"
                                style={{
                                    border: nameTitleView ? '1px solid #0E6AF4' : ''
                                }}
                            >
                                <input 
                                    type="text"
                                    placeholder="이름 입력" 
                                    className="input_pw"
                                    name="name"
                                    value="이름"
                                    readOnly
                                />
                            </div>
                        </div>
                        :
                        <div className="input_box">
                            <div 
                                className="input_div pw_div"
                                style={{
                                    border: idTitleView ? '1px solid #0E6AF4' : ''
                                }}
                            >
                                {idTitleView &&
                                    <div className="input_focus pw_focus">
                                        <p>이메일</p>
                                        <span 
                                            className="input_aster"
                                            style={{
                                                left: '32px',
                                                top: '-2px'
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>
                                }
                                <input 
                                    type="text"
                                    placeholder="이메일 입력" 
                                    className="input_pw"
                                    name="login_id"
                                    value={idValue}
                                    onChange={InputChange}
                                    onBlur={() => {
                                        setIdTitleView(false)
                                    }}
                                />
                                {idAster && 
                                    <span 
                                        className="input_aster"
                                        style={{
                                            left: '94px',
                                            top: idTitleView ? '20px' : '15px'
                                        }}
                                    >
                                        *
                                    </span>
                                }
                            </div>
                            {idErr == 2 && <span className="err_msg id">이메일 형식이 올바르지 않습니다.</span>}

                            <div 
                                className="input_div pw_div"
                                style={{
                                    border: nameTitleView ? '1px solid #0E6AF4' : ''
                                }}
                            >
                                {nameTitleView &&
                                    <div className="input_focus pw_focus">
                                        <p>이름</p>
                                        <span 
                                            className="input_aster"
                                            style={{
                                                left: '21px',
                                                top: '-2px'
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>
                                }
                                <input 
                                    type="text"
                                    placeholder="이름 입력" 
                                    className="input_pw"
                                    name="name"
                                    value={nameValue}
                                    onChange={InputChange}
                                    onBlur={() => {
                                        setNameTitleView(false)
                                    }}
                                    maxLength={10}
                                />
                                {nameAster && 
                                    <span 
                                        className="input_aster"
                                        style={{
                                            left: '80px',
                                            top: nameTitleView ? '20px' : '15px'
                                        }}
                                    >
                                        *
                                    </span>
                                }
                            </div>
                            {nameErr == 1 && <span className="err_msg id">이름이 올바르지 않습니다.</span>}
                        </div>          
                    } */}


                    {/* <div className="license_chk_box">
                        <input type="radio" id="license1" name="license" value={1} onChange={handleChange} checked={licenseStatus}/>
                        <label htmlFor="license1">라이선스 활성</label>

                        <input type="radio" id="license2" name="license" value={0} onChange={handleChange} checked={!licenseStatus}/>
                        <label htmlFor="license2">라이선스 비활성</label>
                    </div> */}

                    {(buttonCancel || button || longButton) &&
                        <div
                            className="popup_btn_box"
                            style={{ width: '100%' }}
                        >

                            {buttonCancel && (
                                <button
                                    className="button_cancel"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            setFunction();
                                        } else {
                                            if (cancelFunc) cancelFunc();
                                            dispatch(close());
                                        }
                                    }}
                                >
                                    {buttonCancel}
                                </button>
                            )}
                            {button && (
                                <button
                                    className="button_success"
                                    disabled={popType === "group" ? (groupNameValue.length === 0) :
                                        member_set ? dropGroup === '조직 전체' ? true : false : (!memberPlusEmailValue && memberPlusEmailErr != 1)}
                                    onClick={async () => {
                                        if (popType === "group") {
                                            // KRCHOI
                                            if (groupNameValue) {
                                                dispatch(loadingStart());
                                                const newOrg = await API.post(`team`, { name: groupNameValue, userId: mbData.idx, teamId: teamId });
                                                console.log("newOrg : ", newOrg);
                                                if (newOrg.data.msg === 'err1') {
                                                    dispatch(open({
                                                        component:
                                                            <Popup01
                                                                max_width={'300px'}
                                                                x_btn={false}
                                                                text1={lang === 0 ? '이미 등록된 조직이름입니다.' : 'The organization name is already registered.'}
                                                                longButton={lang === 0 ? '확인' : 'OK'}
                                                            />
                                                    }));

                                                    dispatch(loadingEnd());
                                                } else {
                                                    dispatch(open({
                                                        component:
                                                            <Popup01
                                                                max_width={'300px'}
                                                                x_btn={false}
                                                                text1={`${groupEdit ? '수정' : '등록'}되었습니다.`}
                                                                longButton={lang === 0 ? '확인' : 'OK'}
                                                            />
                                                    }));

                                                    dispatch(loadingEnd());
                                                }
                                            }
                                        }

                                        console.log("plusMember : ", plusMember, ", member_set : ", member_set);
                                        if (plusMember) {
                                            if (mbData.mb_email === memberPlusEmailValue) {
                                                dispatch(open({
                                                    component:
                                                        <Popup01
                                                            max_width={'300px'}
                                                            x_btn={false}
                                                            text1={`본인은 초대할 수 없습니다.`}
                                                            longButton={lang === 0 ? '확인' : 'OK'}
                                                        />
                                                }));
                                                return;
                                            }
                                            if (!memberPlusEmailValue) {
                                                setMemberPlusEmailErr(4);
                                            } else {
                                                console.log("memberPlusUser : ", memberPlusUser);
                                                if (memberPlusUser) {
                                                    const sender = {
                                                        from: mbData.idx,
                                                    }
                                                    const result = await API.post(`team/${teamId}/email/${memberPlusUser.id}`, sender);
                                                    console.log("result : ", result);
                                                    let msg = '';
                                                    if (result.data?.msg === 'err4') {
                                                        msg = lang === 0 ? '다른 조직에 소속된 멤버입니다.' : 'A member belonging to another organization.';
                                                    } else if (result.data?.msg === 'err5') {
                                                        msg = lang === 0 ? '다른 조직에 소속된 멤버입니다.' : 'A member belonging to another organization.';
                                                    } else {
                                                        msg = lang === 0 ? '초대 메일을 발송했습니다.' : 'Invitation email sent.';
                                                        dispatch(setTeams(result.data.teams));
                                                    }

                                                    dispatch(open({
                                                        component:
                                                            <Popup01
                                                                max_width={'300px'}
                                                                x_btn={false}
                                                                text1={msg}
                                                                longButton={lang === 0 ? '확인' : 'OK'}
                                                            />
                                                    }));
                                                } else {
                                                    if (memberPlusEmailErr === 1) {
                                                        dispatch(open({
                                                            component:
                                                                <Popup01
                                                                    max_width={'300px'}
                                                                    x_btn={false}
                                                                    text1={`가입된 계정이 아닙니다.`}
                                                                    text3_b={'조직에 초대하시겠습니까?'}
                                                                    button={'초대'}
                                                                    buttonCancel={'취소'}
                                                                    setFunc={() => {
                                                                        PlusMemberFunc()
                                                                    }}
                                                                />
                                                        }));
                                                    } else {
                                                        dispatch(open({
                                                            component:
                                                                <Popup01
                                                                    max_width={'300px'}
                                                                    x_btn={false}
                                                                    text1={`가입된 계정이 아닙니다.`}
                                                                    text3_b={'조직에 초대하시겠습니까?'}
                                                                    button={'초대'}
                                                                    buttonCancel={'취소'}
                                                                    setFunc={() => {
                                                                        PlusMemberFunc()
                                                                    }}
                                                                />
                                                        }));
                                                    }
                                                }
                                            }
                                        }

                                        if (member_set) {
                                            dispatch(loadingStart());
                                            const moveTeam = teams.find((x) => x.name === dropGroup);
                                            console.log("moveTeam : ", moveTeam);
                                            const result = await API.post(`team/move/${teamId}/${moveTeam.id}/${member_email}`);
                                            console.log("move, result : ", result);
                                            dispatch(loadingEnd());

                                            if (result.data?.msg === 'success') {
                                                const newTeams = result.data?.teams;
                                                console.log("newTeams : ", newTeams);
                                                dispatch(setTeams(newTeams));
                                                dispatch(open({
                                                    component:
                                                        <Popup01
                                                            max_width={'300px'}
                                                            x_btn={false}
                                                            text1={`수정되었습니다.`}
                                                            longButton={lang === 0 ? '확인' : 'OK'}
                                                        />
                                                }));
                                            }
                                            // setTimeout(() => {

                                            // }, 1000);
                                        }
                                        /* if(member_set) {
                                            if(licenseStatus === 1) {
                                                dispatch(open({
                                                    component: 
                                                        <Popup01
                                                            max_width={'300px'}
                                                            text1={'라이선스를 할당하시겠습니까?'}
                                                            buttonCancel={'닫기'}
                                                            button={'할당'}
                                                        />
                                                }));
                                            } else {
                                                dispatch(open({
                                                    component: 
                                                        <Popup01
                                                            max_width={'300px'}
                                                            text1={'라이선스를 제거하시겠습니까?'}
                                                            buttonCancel={'닫기'}
                                                            button={'제거'}
                                                        />
                                                }));
                                            }
                                        } else {
                                            if(valueSuc) {
                                                dispatch(open({
                                                    component: 
                                                        <Popup01
                                                            max_width={'400px'}
                                                            text1={'해당 멤버를 등록하시겠습니까?'}
                                                            text1_b={`${idValue}(${nameValue})`}
                                                            buttonCancel={'닫기'}
                                                            button={'등록'}
                                                            setFunc={() => {
                                                                PlusMemberFunc()
                                                            }}
                                                        />
                                                }));
                                            } else {
                                                dispatch(open({
                                                    component: 
                                                        <Popup01
                                                            max_width={'300px'}
                                                            text1={'유효하지 않은 정보입니다.'}
                                                            longButton={'확인'}
                                                        />
                                                }));
                                            }
                                        } */
                                    }}
                                >
                                    {
                                        plusMember && memberPlusEmailErr === 1 && '초대 및 '
                                    }
                                    {button}
                                </button>
                            )}
                            {longButton && (
                                <button
                                    className="button_success long"
                                    onClick={() => {
                                    }}
                                >
                                    {longButton}
                                </button>
                            )}
                        </div>
                    }
                </div>
            </div>
        </>
    );
}
